import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/template/editor';
const serviceName = "Editor-Service: ";

export default class EditorService {

  static async getPreview(imageFromWYSIWYG, successF, errorF) {
    let formData = new FormData();
    formData.append('userImage', imageFromWYSIWYG, 'image.png');

    await WrapperService.post(API_URL + '/preview', formData, serviceName, successF, errorF);
  }

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readTemplateHtmlById(id, successF, errorF) {
    await WrapperService.get(API_URL + '/html/' + id, null, serviceName, successF, errorF);
  }

  static async publishAdvert(advertData, successF, errorF) {
    await WrapperService.post(API_URL + '/publish', advertData, serviceName, successF, errorF);
  }

  static async saveTemplate(templateData, successF, errorF) {
    if (templateData.id) {
      await WrapperService.put(API_URL + '/' + templateData.id, templateData, serviceName, successF, errorF);
    } else {
      await WrapperService.post(API_URL, templateData, serviceName, successF, errorF);
    }
  }

  static async deleteTemplate(templateId, successF, errorF) {
    await WrapperService.delete(API_URL + '/' + templateId, null, serviceName, successF, errorF);
  }

}